"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreespinRespinZeroBetController = void 0;
/**
 * Created by Ning Jiang on 10/10/2019.
 */
const GameMode_1 = require("../../core/gamemode/GameMode");
const ZeroBetController_1 = require("../../core/zerobet/ZeroBetController");
class FreespinRespinZeroBetController extends ZeroBetController_1.ZeroBetController {
    constructor() {
        super();
    }
    getZeroBetNumberLeft(data) {
        return data.freespinsLeft;
    }
    shouldSubtractZeroBetCounter() {
        return false;
    }
    shouldShowZeroBetCounter() {
        return true;
    }
    calculateIsTriggered(data) {
        return data.nextMode === GameMode_1.GameMode.FREESPIN_RESPIN;
    }
}
exports.FreespinRespinZeroBetController = FreespinRespinZeroBetController;
//# sourceMappingURL=FreespinRespinZeroBetController.js.map